import {saveData} from "../db/db_helper"
import SyncController from "../APIController/SyncController";
import { emitWorkspaceChange } from "../db/workspaceEvents";

// Helper to react to WS messages and save changes in Indexed DB
const WebsocketActions = () => {
    const {fetchOffers, fetchCategories, fetchDiscounts, fetchExtras, fetchOrders, fetchProducts, fetchWorkspace, fetchRegisterEntries, fetchWorkspaceUser, fetchTimeTracking} = SyncController()

    const handleOrderUpdate = async() => {
        const orders = await fetchOrders();
        if(orders){
            await saveData("orders", orders)
        }
    }

    const handleProductUpdate = async() => {
        const products = await fetchProducts();
        if(products){
            await saveData("products", products)
        }
    }

    const handleExtraUpdate = async() => {
        const extras = await fetchExtras();
        if(extras){
            await saveData("extras", extras)
        }
    }

    const handleCategoryUpdate = async() => {
        const categories = await fetchCategories();
        if(categories){
            await saveData("categories", categories)
        }
    }

    const handleDiscountUpdate = async() => {
        const discounts = await fetchDiscounts();
        if(discounts){
            await saveData("discounts", discounts)
        }
    }

    const handleOfferUpdate = async() => {
        const discounts = await fetchOffers();
        if(discounts){
            await saveData("offers", discounts)
        }
    }

    const handleWorkspaceUpdate = async() => {
        const ws = await fetchWorkspace();
        if(ws){
            await saveData("workspace", ws)
            emitWorkspaceChange(0)
        }
    }

    const handleRegisterEntrieeUpdate = async() => {
        const ws = await fetchRegisterEntries();
        if(ws){
            await saveData("register_entries", ws)
        }
    }

    const handleWSUserUpdate = async()=>{
        const data = await fetchWorkspaceUser()
        if(data){
            await saveData("workspace_user", data)
        }
    }

    const handleTimeTrackingUpdate = async()=>{
        const data = await fetchTimeTracking()
        if(data){
            await saveData("time_tracking", data)
        }
    }

    return { 
        handleOrderUpdate, 
        handleProductUpdate, 
        handleExtraUpdate, 
        handleCategoryUpdate, 
        handleDiscountUpdate, 
        handleOfferUpdate, 
        handleWorkspaceUpdate, 
        handleRegisterEntrieeUpdate, 
        handleWSUserUpdate,
        handleTimeTrackingUpdate 
    }
}

export default WebsocketActions;